<template>
  <div class="branch">
    <b-row>
      <b-col cols="2">
        <p class="text-header">Branch</p>
      </b-col>
      <b-col cols="10">
        <div class="d-flex justify-content-end">
          <div class="g-form">
            <div class="input">
              <b-form-input
                v-model="filter.keyword"
                placeholder="Branch"
                @focus="iconSearch = true"
                @blur="iconSearch = false"
                @keyup.enter="handleSearch"
              ></b-form-input>
              <b-button
                class="search"
                :class="iconSearch ? 'active-border' : ''"
                @click="handleSearch"
              >
                <b-icon
                  stacked
                  icon="search"
                  scale="0.5"
                  variant="grey"
                ></b-icon>
              </b-button>
            </div>
          </div>
          <b-button class="btn-filter mr-2" @click="onClickCreate">
            <span class="d-none d-md-block">
              <span class="">Create</span>
            </span>
          </b-button>
          <b-button class="btn-filter mr-2" @click="onClickOpenSideBar">
            <span class="d-none d-md-block">
              <span class="">Filter</span>
            </span>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <Table
      :items="items"
      :fields="fields"
      :isBusy="isBusy"
      :rows="rows"
      :filter="filter"
      @editVenue="editVenue"
      :pageOptions="pageOptions"
      @filterPage="filterPage"
      @onChangeStatus="onChangeStatus"
    />

    <FilterBranch
      :visible="visible"
      :provineId="filter.provinceId"
      @closeFilter="closeFilter"
      @searchFilter="searchFilter"
    />
  </div>
</template>

<script>
import Table from "./component/table.vue";
import FilterBranch from "./component/filterBranch.vue";
export default {
  name: "BranchPage",
  components: { Table, FilterBranch },
  data() {
    return {
      id: 0,
      iconSearch: false,

      //state table
      rows: 0,
      isBusy: false,
      items: [],
      fields: [
        {
          key: "id",
          label: "Branch Id",
          class: "w-10px text-nowrap",
        },
        {
          key: "name",
          label: "Branch Name",
          class: "w-50px text-nowrap",
        },
        {
          key: "venueAddress",
          label: "Address",
          class: "w-100px",
        },
        {
          key: "provinceName",
          label: "Province",
          class: "w-50px text-nowrap",
        },
        {
          key: "isActive",
          label: "Status",
          class: "w-50px text-nowrap",
        },
        { key: "actions", label: "Action", class: "w-100px text-nowrap" },
      ],
      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 15, text: "15 / page" },
        { value: 20, text: "20 / page" },
      ],
      filter: {
        keyword: "",
        provinceId: 0,
        skip: 1,
        take: 5,
        page: 1,
      },

      visible: false,
    };
  },
  mounted() {
    this.getBranchList();
  },
  methods: {
    async editVenue(val) {
      this.id = val;

      this.$router.push(`branch/detail/${this.id}`);
    },
    async getBranchList() {
      this.isBusy = true;

      const respone = await this.$services.venue.getVenueList(this.filter);
      if (respone.result === 1) {
        const { data, count } = respone.detail;
        this.items = data;
        this.rows = count;
      }

      this.isBusy = false;
    },
    async onChangeStatus(v) {
      const respone = await this.$services.venue.setStatusVenue(
        v.id,
        Boolean(v.isActive)
      );
    },
    handleSearch() {
      this.filter.skip = 1;
      this.filter.page = 1;
      this.getBranchList();
    },
    onClickCreate() {
      this.$router.push("/createBranch");
    },
    filterPage(obj) {
      let { page } = obj;
      this.filter.skip = page;
      this.getBranchList();
    },
    onClickOpenSideBar() {
      this.visible = true;
    },
    closeFilter() {
      this.visible = false;
    },
    searchFilter(val) {
      this.visible = false;
      this.filter.provinceId = val;
      this.filter.skip = 1;
      this.filter.page = 1;
      this.getBranchList();
    },
  },
};
</script>

<style lang="scss" scoped>
.branch {
  .g-form {
    width: 100%;
    margin-right: 10px;
  }
  .text-header {
    color: #092d53;
    font-weight: 600;
    font-size: 20px;
    text-transform: uppercase;
  }
}
</style>
